var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusMath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2038_4054",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2038_4054",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABRklEQVR4nO3dMWrDQBQAUV3Cp8hdch/BwPfNE9YY0tmVvRM8D7bbQvyRCgkWHUeSJEmSJEmSlznP8zIz10dr7SnBmwBfM/PzaK09BSnIZ6InxIWCuFAQFwriQkFcKIgLBXGhIC4UxIWCuFAQFwriQkFcKIgLBXGhIC4UxIWCuFAQFwriQkFcKIgLBXGhIC4UxIWCuFAQFwriQkFcKMifdRBmDWTnmpnvZ+dD1p7d1/mWQ0P3E0rPhtGa2wyuBRnVzVCQ2R+hILN/8AWZ/cMuyOwfcEFm/1ALMvsH+X+C9GKI68XQgD6duFAQFwriQkFcKIgLBXGhIC4UxIWCuFAQFwriQkFcKIgLBXGhIC4UxIWCuFAQFwriQkFcKIgLBXGhIC4UxIWCuFAQFwriQkFcKIgLBXGhIC4UxOXs16tJkiRJkiTJsdsvhPjRAfkh7CYAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusMath);
export default __webpack_public_path__ + "static/media/PlusMath.8b11a318759f620bbff6d7f5d31d8706.svg";
export { ForwardRef as ReactComponent };